import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


// import {
// 	statisticsAction,
// 	statisticsCloseAction
// } from '../../../actions/settingsAction.js';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';

import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
const RoleAccessControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const defaultChecked = false;

	const [selectedItems, setSelectedItems] = useState([]);
	const [isChecked, setIsChecked] = useState({ defaultChecked });


	const [checkbox, setCheckbox] = useState([]);

	const history = useHistory();
	// const [data, setData] = useState([]);
	// const [leavedetaildata, setLeaveDetailData] = useState([]);
	


	const { search } = useLocation();
	const searchparams = new URLSearchParams(search);
	const param = searchparams.get("user_id");
	//const handleChange = (e) => setCheckbox(e.target.checked);


const handleUpdate = async (user_id) => {
		window.open(API_BASE_URL +'/nodue_interview_answers_detail_pdf/'+user_id, '_blank')

		// axios.get(API_BASE_URL +'/payslip/'+id, {
		// 	headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		// })
		// .then(res1 => setUser(res1.data))
		// .catch(err => console.log(err))
	   };






  const [data, setData] = useState(null);
  const [nodueinterviewanswers, setNodueInterviewAnswers] = useState(null);

  useEffect(() => {
  axios
    .get(`${API_BASE_URL}/nodue_interview_answers_detail/${param}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
    })
    .then((res) => {
    //   console.log(res.data.nodue_detail);
      setData(res.data.nodue_detail);
      setNodueInterviewAnswers(res.data.nodue_interview_answer_detail);
    })
    .catch((err) => console.log(err));
}, [param]);
  if (!data) return <h3>Loading...</h3>;


	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />


						</div>
					</div>


					<div className="section-body mt-3">
					<div className="container-fluid">
						<div className="row">
							
						<div style={{ width: "900px", margin: "20px auto", fontFamily: "Arial" }}>

	  {/* Header */}
	  {/* <h2 style={{ textAlign: "center" }}>
		Payslip for the month of {data.salary.payment_month}
	  </h2> */}

	  {/* Employee Details Table */}
	  <div style={{  padding: "10px", display: "inline-block" }}>
    <button 
        className="btn" 
        style={{ backgroundColor: "#e64219ff" }} 
        onClick={() => handleUpdate(param)}
    >
        Print
    </button>
</div>
	  <table border="1" width="100%" cellPadding="5" style={{ marginBottom: "20px" }}>
		<tbody>
		  <tr>
			<td>Name</td><td>{data.full_name}</td>
			<td>Employee Id</td><td>{data.employee_id}</td>
		  </tr>
		  <tr>
			<td>Department</td><td>{data.dept_name}</td>
			<td>Designation</td><td>{data.desgn_name}</td>
		  </tr>
		  <tr>
			<td>Commencement Date</td><td>{data.join_date}</td>
			<td>Last Day of Employment</td><td>{data.releave_date}</td>
		  </tr>
		 
		  
		</tbody>
	  </table>

	  {/* Earnings & Deductions */}
	  <table border="1" width="100%" cellPadding="5">
		<thead style={{ backgroundColor: "#c4e5fd" }}>
		  <tr>
			<th>Questions</th>
			<th>Answers</th>
			
		  </tr>
		</thead>
		<tbody>
	{nodueinterviewanswers && nodueinterviewanswers.length > 0 ? (
	  nodueinterviewanswers.map((row, i) => (
		<tr key={i}>
		  <td>{row.questions}</td>
		  <td>{row.answers}</td>
		 
		</tr>
	  ))
	) : (
	  <tr>
		<td colSpan="3" style={{ textAlign: "center" }}>No Records Found</td>
	  </tr>
	)}
  </tbody>
	  </table>

	</div>
							




						</div>
					</div>

					</div>




				</div>
			</div>









		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(RoleAccessControl);